import { fetchWithAuth, getCSRFToken } from '../auth';

const DFN_URL = process.env.REACT_APP_ICC_TOOL_API_HOST + 'dfn/';

export async function listDFNs() {
    return fetchWithAuth(DFN_URL, {
        credentials: 'include',
        headers: { 'X-CSRFToken': getCSRFToken() },
    });
}

export async function createDFN(name) {
    return fetchWithAuth(DFN_URL, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCSRFToken(),
        },
        body: JSON.stringify({ name }),
    });
}

export async function updateDFN(id, name) {
    return fetchWithAuth(`${DFN_URL}${id}/`, {
        method: 'PATCH',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCSRFToken(),
        },
        body: JSON.stringify({ name }),
    });
}

export async function deleteDFN(id) {
    return fetchWithAuth(`${DFN_URL}${id}/`, {
        method: 'DELETE',
        credentials: 'include',
        headers: { 'X-CSRFToken': getCSRFToken() },
    });
}
